import Emojis from './Emojis';

export default Emojis;
